import { dayjs } from "neetocommons/utils";

import { extendDayjs } from "./range";

// Add range and overlap functions to dayjs
const dayjsExtended = extendDayjs(dayjs);

export default dayjsExtended;
